<template>
  <div class="animated fadeIn">     
    <b-row>
      <b-col md="12">
<!--          <b-breadcrumb :items="breadcrumbs"/>       
 -->        <b-card>
          <div slot="header">
            <strong>ME Zone Management List</strong>
            <div class="card-header-actions" >                
              <!-- <button class="btn btn-sm btn-primary mr-4 btn-pill" v-on:click="zoneadd()"  type="button">Create Pallet</button>  -->
         
       
                <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" type="button"><i class="fa fa-refresh"></i></button> 
            </div>
          </div>
          <!-- <div id="overlay" >
             <div class="loader"></div>
           </div>
 -->
         
          <div id="addzone"  style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);display:none;" class="mb-1">
              <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                <b-row md="12"> 
                  <b-col md="4">
              
                      <b-form-group>
                        <label for="pincode">Country</label>
                       <!--  {{countrylistarr}} -->
                        <b-input-group class="mb-3">
                          <b-form-select 
                          v-model="customer.country" name="country" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.country') }"  >
                          
                          <option  v-for="item in countrylistarr"
                          :value="item.country">{{item.country | capitalize}}</option>
                          
                        </b-form-select>
                        </b-input-group>
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('country')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.country')" id="statustxt" class="help text-danger">{{ errors.first('form-1.country') }}
                        </code>
                        </b-input-group>
                      </b-form-group>
                     </b-col>
                  <b-col md="4">
                      <b-form-group v-if="customer.country!='oman'">
          <!--               <b-form-group> -->
                        <label for="pincode">Mode Of transport</label>
                        <b-input-group class="mb-3">
                          <b-form-select v-model="customer.transport" name="transport" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.transport') }">
                          <option value="">--Select--</option>
                          <option value="Air">Air</option>
                          <option value="Land">Land</option>
                        </b-form-select>
                        </b-input-group>
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('transport')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.transport')" id="statustxt" class="help text-danger">{{ errors.first('form-1.transport') }}
                        </code>
                        </b-input-group>
                      </b-form-group>
                      <b-form-group v-else>
                        <label for="pincode">Mode Of transport</label>
                        <b-input-group class="mb-3">
                          <b-form-select v-model="customer.transport" name="transport" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.transport') }">
                          <option value="">--Select--</option>
                          <!-- <option value="Air">Air</option> -->
                          <option value="Land">Land</option>
                        </b-form-select>
                        </b-input-group>
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('transport')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.transport')" id="statustxt" class="help text-danger">{{ errors.first('form-1.transport') }}
                        </code>
                        </b-input-group>
                      </b-form-group>
                  </b-col>
                                          
               
                
                  <b-col sm="4">
                    <b-button style="margin-top: 27px;"variant="primary" size="md" type="submit">Save</b-button>
                  </b-col>
                </b-row>  
              </b-form>
          </div>
          
               <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">
               {{ this.totalRows }}</span></b> </p>
              </b-col>  
                    <div id="printableArea" >
            <div class="page-break" v-for="item in linehaularr" >
              <table>
                  <tr >
                    <td >
                     <div>
                      <table border = '1' class="stickertable"  >
                        <tr>

                          <td>
                          <div style='text-align: center;font-size: 2px;'>
                          <img id='test'/>
                          <div id="app" >
                                  {{item.mezone_id}}
                          <barcode v-bind:value="item.mezone_id">
                          Show this if the rendering fails.
                          </barcode>
                          </div>
                          </div>
                          </td>
                        </tr>

                      <tr>
                        <td colspan ='2' class="addpad">

                          <!-- <span style ='font-size: 35px;  display: block;
  margin-bottom: 8px;'><b>{{item.master_awb}}</b></span> <br>
                          -->
                          <span style ='font-size: 30px;  display: block;
  margin-bottom: 8px;'><b>Zone Title:</b> &nbsp;{{item.mezone_name}}</span>
  <br>
                          <span style ='font-size: 30px; display: block;
  margin-bottom: 8px;' >Country Code:<b>{{item.country_code}}</b></span><br>
                          <!-- <span style ='font-size: 30px;'>Created Date: {{item.created_date}}</span><br> -->
                         <!--  <span style ='font-size: 20px;'>Created_by: {{item.created_by}}</span><br> -->
                        
                         
                          <br>
                        </td>
                      </tr>
                     
                     </table>
                   </div>
                    </td>
                  </tr>
                </table>
            </div>           
          </div>
          <b-col sm="12" >
          <b-table show-empty stacked="md"  :items="items" :busy="isBusy"  :fields="fields1"  :current-page="currentPage"   :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>  
            <template slot="actions" slot-scope="row">
             
                  <input @change="setStickerHTMl($event,row.item)" type="radio" name="radAnswer" v-model="row.item.selected" class="shipmentscheckbox" id="stiker" :checked="checkedData" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <b-button  id="printbutton" variant="primary" size="sm" value="print a div!" @click="barcodedata('printableArea',row.item)" style="background: #b0c4de !important;color: #000 !important;" >Print Zone </b-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              
                   <b-button size="sm" @click="showinfoModal(row.item)" style="background: #b0c4de !important;color: #000 !important;" class="mr-1">
                    View Shipment
                  </b-button>

                    <b-button size="sm" @click="meproductdetails(row.item)" style="background: #b0c4de !important;color: #000 !important;" class="mr-1">
                    View Products
                  </b-button>
                
                </template>

        
          </b-table>
        </b-col>


                  <b-modal size="xl" title="ME Zone Product Listing" v-model="meproductmodel">
          <!-- <template slot="modal-header" slot-scope="{ close }">
          <h5>Shipment Listing</h5>
          </template> -->
            <div id="overlay" >
             <div class="loader"></div>
           </div>

          <!-- v-if="this.totalRows >0"  -->
          <b-row >
             <b-col sm="6" class="my-1">
                <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="productfilter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!productfilter" @click="productfilter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" class="text-right">
                <b-button v-if="this.total_row_product >0"  @click="downloadCSV" variant="primary" size="md" >Download </b-button> 
               <p > <b>Total Records :<span style="color:red;">{{total_row_product}}</span></b> </p>
              </b-col> 
          </b-row>
          <b-table show-empty stacked="md"  :items="meproductlisting" :busy="isBusyproduct"  :fields="productfields"  :current-page="currentPageproduct"   :per-page="perPageproduct"  :filter="productfilter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>  
           <!--  {{row.item.user_type == 0 ? 'Normal ' : row.item.user_type == 1 ? 'Privilage':'Warehouse'}} -->
             <template slot="modetransport" slot-scope="row">
             <b-button size="sm" @click="changemode(row.item)" class="mr-1">
                 <span>{{row.item.modeoftransport}}  </span>  
              </b-button>
            </template>

       
          </b-table>

      <b-col md="12" class="my-1 " v-if="this.total_row_product > 10">
            <b-pagination
                v-model="currentPageproduct"
                :total-rows="total_row_product"
                :per-page="perPageproduct"
                class="my-0"
              ></b-pagination>
          </b-col>    


    
         <!--  <template slot="modal-footer" slot-scope="{ hide }"> -->
            <!-- Emulate built in modal footer ok and cancel button actions -->
          <!--   <b-button size="sm"  @click="closeeditAgentMaster()" >
              Cancel
            </b-button> -->
            <!-- Button with custom close trigger value -->
          <!-- </template> -->
      </b-modal> 

          <b-modal size="lg" title="ME Zone Listing" v-model="melistingmodel">
          <!-- <template slot="modal-header" slot-scope="{ close }">
          <h5>Shipment Listing</h5>
          </template> -->
            <b-row>
              <b-col sm="12" class="text-right">
               <!--  <b-button v-if="this.totalRows >0"  variant="primary" size="md" @click="downloadCSV">Download </b-button>  -->
               <p > <b>Total Records :<span style="color:red;">{{total_row_shipment }}</span></b> </p>
              </b-col> 
          </b-row>
          <b-table show-empty stacked="md"  :items="melisting" :busy="isBusy"  :fields="fields"  :current-page="currentPage"   :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>  
           

        
          </b-table>
      <!--     <div >
     <label  v-if="shipmentlist.length>0"><b>Shipping id</b></label>
     <label v-else><b>Shippingid's are not Available</b> </label>
   </div> -->
         <!--  <div class="row" >
    
      <div   v-for="(item, index) in shipmentlist">
       
          
        {{ item.shippingid}}<span >&nbsp;&nbsp;&nbsp;,</span>

      </div>
    </div>
     -->
      <b-col md="12" class="my-1 " v-if="this.total_row_shipment > 10">
            <b-pagination
                v-model="currentPage"
                :total-rows="total_row_shipment"
                :per-page="perPage"

                class="my-0"
              ></b-pagination>
          </b-col>    


    
         <!--  <template slot="modal-footer" slot-scope="{ hide }"> -->
            <!-- Emulate built in modal footer ok and cancel button actions -->
          <!--   <b-button size="sm"  @click="closeeditAgentMaster()" >
              Cancel
            </b-button> -->
            <!-- Button with custom close trigger value -->
          <!-- </template> -->
      </b-modal> 
      <b-modal id="modall" v-model="modeconfirmation" hide-footer title="Change Mode Of Transport">
                <p class="my-4"><strong>Mode of Transport is&nbsp;</strong> <b style="color:red;font-size:18px">{{transportmode}}</b><strong>.
                  <br>Are you really want to change Mode of Transport to &nbsp;<b style="color:red;font-size:18px" v-if="this.transportmode=='AIR'">ROAD</b>
                  <b style="color:red;font-size:18px" v-if="this.transportmode=='ROAD'">AIR</b>
                </strong>&nbsp;<b>?</b></p>
                 <div class="col-md-12 mb-4 text-center">
                               <b-button  variant="danger" style="float: right;" @click="conformationcancel()" >
                              Cancel
                             </b-button>
                                <button @click="changemodeoftransport()"   class="btn btn-success"  style="float: right;margin-right:10px;">
                                    Yes
                                </button>

                            </div>
               
            </b-modal>

          <b-col md="12" class="my-1 " v-if="this.totalRows > 10">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col>    
        </b-card>
       
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
import VueBarcode from 'vue-barcode';
export default {
  name: 'zonemaster', 
  data: function() {
    return {
      name: 'zonemaster',
      isBusy: false,
      isBusyproduct:false,
      breadcrumbs: [{
        text: 'Dashboard',
        href: '/dashboard'
      },{
        text: 'Zone Master',
        active: true
      }],
      add: true,
      checkedData:false,
          modeconfirmation:false,     
       items:[],
       linehaularr:[],
       transportmode:'',
       productshippingid:'',
       productcountrycode:'',
       shipments:[],
       noshipments:[],


     fields1: [
          { key: 'mezone_name', label: 'Zone Name', sortable: true, sortDirection: 'desc' },
          { key: 'country_code', label: 'Country Code', sortable: true, sortDirection: 'desc' },
          
          { key: 'created_date', label: 'Created Date', sortable: true},
          // { key: 'transport_mode', label: 'Mode Of Transport', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          
          { key: 'actions', label: 'Actions' },
         
        
       ], 
        fields: [
          { key: 'shippingid', label: 'Shipping Ids', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'mezone_name', label: 'Zone Name', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'country_code', label: 'Country Code', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'transport_mode', label: 'Mode Of Transport', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
         // { key: 'count', label: 'Number of Count', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
         
        
       ], 
       productfields:[
          { key: 'shippingid', label: 'Shipping Id', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'productid', label: 'Product ID', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'productname', label: 'Product Name', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'hsncode', label: 'HSN Code', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'productquantity', label: 'Product Quantity', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'productvalue', label: 'Product Value', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'countrycode', label: 'Country Code', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'countryoforigin', label: 'Country Of Origin', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
            { key: 'modetransport', label: 'Mode Of Transport', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
       ],
        bordered: true,
        totalRows: 0,
        total_row_shipment:0,
        total_row_product:0,
        mezoneidcsv:'',
        mezoneid:'',
        showSelectAll : true,
        currentPage: 1,
        currentPageproduct:1,
        perPageproduct:10,
        perPage:  10,
        pageOptions: [5, 10, 15],
        sortBy: null,
        options:[],
        // fields: { text: 'name', value: 'id' },
        zoneno:'',
        value2:[],
        tags:[],
        tags1:[],
        tags2:[],
         texts: [],
        countrylistarr:[],
        pincodeoptions:[],
        shipmentlist:[],
        meproductlisting:[],
        melisting:[],
        sortDesc: false,
        allowCustomValue : true,
        sortDirection: 'desc',
        filter: null,
        productfilter:null,
        customer:{},

        editAgentMaster:false,
        melistingmodel: false,
        meproductmodel:false,
        selected_mezone: '',
        selected_zone_id:'',
        
    }
  },
   components: {
    'barcode': VueBarcode
  },
  created: function() { 
    this.countrylist(); 
    this.displaydata();
    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
 
  },
  computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
     filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
    
  methods: {
     
    validateForm(scope) {
       this.$validator.validateAll(scope).then(result => {
        if (result) {          
          this.addpalletInfo();
        }
      });
    },
    
    
    zoneadd: function() {
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      this.errors.clear("form-1");
   
      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var addzone = document.getElementById("addzone");
      addzone.style.display = "block";
    
    },
    //    settransportmode: function() {
    // alert("country change")

    // },
           setStickerHTMl(e,value){
            this.selected_zone_id=value.mezone_id;
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            // if(e.target.checked==true){
            //   document.getElementById("printbutton").style.display = "block";
            // }
            
            // console.log("hhhhh",e.target.checked);
             this.linehaularr=[];
          // alert("i m in setstiker")
          // alert(this.checkedData);
      // this.qrvalue="";
         this.checkedData=true;
    
 const obj = {

         mezone_id:value.mezone_id,
         mezone_name:value.mezone_name,
         country_code:value.country_code,
         created_date:value.created_date,
         // created_by:value.created_by
         
       

      }
// console.log(this.linehaularr)
           

           

            // this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getlinehaulpalletdetails`,obj)
            // .then(result => {

              this.linehaularr.push(obj);

              // = result.body.returnvalue;
               // this.qrvalue=result.body.returnvalue[0].pallet_id;
               
              
             // var qr =""+this.qrvalue;
              // alert(qr);

               // this.valuess=qr.trim();;
              //alert(this.valuess);

              // console.log(this.qrvalue)

            // })
            // .catch(ex => {
            //   console.log('error-----', ex)
            // });



    
    },
            barcodedata(printableArea,value){
  //alert(this.checkedData);
  // console.log("Event",event.target.checked);
//this.checkedData=true;
// console.log("Checkdata",this.checkedData);
if(this.checkedData==true && this.selected_zone_id==value.mezone_id)
{

//alert(" i m in  if");

      //document.getElementById("printableArea").style.display = "none";

     var printContents = document.getElementById("printableArea").innerHTML;


     // var originalContents = document.body.innerHTML;
     // document.body.innerHTML = printContents;
     // window.print();
     // document.body.innerHTML = originalContents;


    var disp_setting="toolbar=yes,location=no,";
    disp_setting+="directories=yes,menubar=yes,";
    disp_setting+="scrollbars=yes,width=650, height=600, left=100, top=25";
       var content_vlue = printContents;
       var docprint=window.open("","",disp_setting);
       docprint.document.open();
       docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
      docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
      docprint.document.write('<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">');
      docprint.document.write('<head>');
      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write('font-family:verdana,Arial;color:#000;');
      docprint.document.write('font-family:Verdana, Geneva, sans-serif; font-size:20px;}');
      docprint.document.write('a{color:#000;text-decoration:none;} ');
      docprint.document.write('.stickertable{ border-collapse: collapse;margin-bottom: 20px; width:540px;height:540px} ');
      docprint.document.write('.printarea{ font-size: 30px;text-align: center;}');

      docprint.document.write('.addpad{ padding: 10px; }');


       docprint.document.write('@media all { .page-break { display: block;vertical-align: middle;margin-top:20px; }}');

docprint.document.write('@media print { .page-break { display: block; page-break-before: always; }}  @page { size: auto;  margin: 0mm; }');        


        docprint.document.write('.stickertable td{ padding-bottom:10px;  }');

        docprint.document.write('@page { size: 101.6mm 152.4mm;}</style>');


        //docprint.document.write('@media print { td.page-break  { display: block; page-break-before: always; } } </style>');  


  

       docprint.document.write('</head><body onLoad="self.print()"><center>');



       // docprint.document.write('<script type="text/javascript">function CloseWindow() { window.close() }');


        // docprint.document.write('<a  onclick="CloseWindow();" href="#">Here</a> to close this window.');
       docprint.document.write(content_vlue);
docprint.document.write('</center></body></html>');
           docprint.document.close();
      // localStorage.removeItem("reloaded");
     // location.reloaded();
       //self.close();
        // this.linehaularr=[];
         // this.checkedData=false;
}
else
{
  alert("Please Select Radion Button");
   // this.$fire({
   //                text:"Please Select Radion Button",
   //                type: "warning",
   //                timer: 30000
   //              }); 
}
    },

   //  closeeditAgentMaster: function() {
   // alert('innn');
   //   this.melistingmodel = false;
   //  },
//      addpalletInfo: function() {
// document.getElementById("overlay").style.display = "block";
//       //alert(this.customer.country);

//        var userdata = localStorage.getItem('userData')
//       var userInfo = JSON.parse(userdata)
      

//      const Obj = {
                
              
//                  countrycode:`${this.customer.country}`,
//                  modeoftransport:this.customer.transport,
//                   hub_id:`${userInfo.pickuplocationmasterid}`,
//                   created_by:`${userInfo.emailid}`
      

                 
                 
//  }
//               // console.log(pincodesave);
//     this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/createlinehaulpallet`,Obj)
      
//         .then((result) => {
          
//          if (result.body.returnmsg === "Successful") {
//                  Utils.notify("Pallet Created successfully", "success");
//                 //  this.$fire({
//                 //   text:"Pallet Created Successfully",
//                 //   type: "success",
//                 //   timer: 30000
//                 // }); 

//         document.getElementById("overlay").style.display = "none";
                  
                 
//                   this.displaydata();
//                   this.$router.push('/LineHaulPalletlisting');
//                 } else {
//             Utils.notify(result.body.returnvalue);
//             // this.$fire({
//             //       text:result.body.returnvalue,
//             //       type: "error",
//             //       timer: 30000
//             //     }); 
//           }
//         })
//         .catch((ex) => {
//           console.log('error-----', ex)
//         })
      
//     },
       countrylist: function() {
        // alert(" countrylist");
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
        const Obj_country = {
                  hub_id:`${userInfo.pickuplocationmasterid}`,
                }
     this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getcountrylist`,Obj_country)
        .then((result) => {
         if (result.body.returnmsg === "Successful") {
                this.countrylistarr  = result.body.returnvalue

                 
                
                } 
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
     

    },

    validateForm5(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
           this.updatepincodes();
        }
      });
    },
    updatepincodes: function() {
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    // console.log(this.texts[0]) 
  // alert("Update");   
    // console.log(this.customer.zonename);
    // console.log(this.tags);

    //  var pincodelistarr=[];
    //    for(var i = 0; i < this.tags.length; i++) {
    //     console.log("val:"+this.tags[i]);
    //       pincodelistarr.push(this.tags[i]);  
    //    }
    var pincodelistarr=[];
       for(var i = 0; i < this.tags.length; i++) {
    if(this.tags[i].text== null || this.tags[i].text=="undefined" || this.tags[i].text=="")
        {
           pincodelistarr.push(this.tags[i]);
          

        }
          else
          {
             pincodelistarr.push(this.tags[i].text);
            
          }
        // console.log("val"+this.tags[i]);
            
       }
     for(var i = 0; i < this.texts.length; i++) {

     pincodelistarr.push(this.texts[i]);
   }
    
      var Obj = {
          zonename : this.customer.zonename,
          pincodes : pincodelistarr,
          // hub_id:`${userInfo.pickuplocationmasterid}`,
      
         
            
      
      };  
       // console.log(Obj);
    
this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/editpincodestozone`,
            Obj
          ).then(result => {
             if (result.body.returnmsg === "Successful") {
            alert("updated successfully");
            // this.$fire({
            //       text:"Updated Successfully",
            //       type: "success",
            //       timer: 30000
            //     }); 

            this.editAgentMaster = false;
            this.customer = {};

            this.displaydata();
             this.tags=[];
              this.$router.push('/zonemaster');
            }
            else if (result.body.returnmsg === "Unsuccessful") {
            Utils.notify(result.body.returnvalue);
            // this.$fire({
            //       text:result.body.returnvalue,
            //       type: "error",
            //       timer: 30000
            //     }); 

            // this.displaydata();
            //  this.tags=[];
            //   this.$router.push('/zonemaster');
          }
          else
          {
           Utils.notify(result.body.returnvalue); 
           // this.$fire({
           //        text:result.body.returnvalue,
           //        type: "error",
           //        timer: 30000
           //      }); 
          }
          })
          .catch(ex => {
            console.log("error", ex);
          });

                
      
    }, 

    downloadCSV: function() {
  // alert(this.mezoneidcsv);
   document.getElementById("overlay").style.display = "block";
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata) 
      // alert()
          const csvObj = {
         mezone_id: this.mezoneidcsv,
        hub_id:`${userInfo.pickuplocationmasterid}`,
       sysusermasterid:`${userInfo.sysusermasterid}`,
       submit_via:'DHL',  
          };
          // console.log("csvobj",csvObj);
          // return false;
this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getproductdetailsagainstmezonecsv`,csvObj)
        .then(result => {
         // console.log(result);
          document.getElementById("overlay").style.display = "none";
          if(result.body=="success")
         {
         alert("Please Check Your Mail For Downlod Link")
          // this.$fire({
          //         text:"Please Check Your Mail For Downlod Link",
          //         type: "success",
          //         timer: 30000
          //       }); 
       }
       else
       {
        alert("Can not Download");
          // this.$fire({
          //         text:"Can not Download",
          //         type: "error",
          //         timer: 30000
          //       }); 
       }
        
        });
        
    },

        // Function For Product Listing 13/09
          meproductdetails: function(value) {
            // console.log(value);
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      // alert(value.pallet_id);
      //alert(" i m in info model");
      this.isBusyproduct=true;
      this.mezoneid=value.mezone_id;
      this.mezoneidcsv=value.mezone_id;
      var productObj = {
         mezone_id:this.mezoneid,
            // mezone_id:value.mezone_id,
            // mezone_name:value.mezone_name,
         // country_code:value.country_code,
         // created_date:value.created_date,
        hub_id:`${userInfo.pickuplocationmasterid}`,
        submit_via:'DHL',
              
            
      
      };  
      // console.log('Params',productObj);
       
       // this.meproductmodel = true;
// getshipmentlistfromlinehaulpallet

         this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getproductdetailsagainstmezone`,productObj)
        .then((result) => {
          // console.log("mezone",result);
          if (result.body.returnmsg === 'Successful') {
             
          
           
               // this.shipmentlist  = result.body.returnvalue
           // console.log(this.shipmentlist);
                
                this.meproductlisting=result.body.returnval;
                // console.log("IIIIIIIddddddddd",this.meproductlisting);
                this.total_row_product=result.body.returnval.length;
                  // console.log("length",this.total_row_product);
                   this.isBusyproduct = !this.isBusyproduct;
               this.meproductmodel =!  this.meproductmodel;
                
          } 
          else {
             this.isBusyproduct = !this.isBusyproduct;
          this.meproductlisting=[];
            this.total_row_product=0;
          this.meproductmodel =!  this.meproductmodel;
            
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    
      
      
    },

    // Function to change Mode of Transport
    changemode:function(value){
      // alert(value.modeoftransport);
      this.transportmode=value.modeoftransport;
      this.productshippingid=value.shippingid;
      this.productcountrycode=value.countrycode;
      this.modeconfirmation =! this.modeconfirmation;
    },

    conformationcancel:function(){
      this.modeconfirmation =! this.modeconfirmation;
    },
    changemodeoftransport:function(){
         var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

        var modeObj = {
         hub_id:`${userInfo.pickuplocationmasterid}`,
         lastmodifiedby:`${userInfo.sysemailid}`,
         modeoftransport:this.transportmode,
         shippingid:this.productshippingid,
         countrycode:this.productcountrycode,
      };
  
       this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/changemodeoftransportofshipment`,
            modeObj
          )
          .then(result => {
             if (result.body.returnmsg === 'Successful') {
              // this.$fire({
            //       text: "Status Approved",
            //       type: "success",
            //       timer: 30000
            //     });
            alert("ModeOfTransport Of Shipment Changed Successfull");
            this.displaydata();
            this.modeconfirmation =! this.modeconfirmation;
             this.meproductmodel =!  this.meproductmodel;
           
            // this.displaydata();
          }
           
          })
          .catch(ex => {
            console.log("error", ex);
          });
     

    },
     
      // console.log("OOOOOOOOOOOOOOOOOOOOOOOOO",value);
      showinfoModal: function(value) {
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      // alert(value.pallet_id);
      //alert(" i m in info model");
      var Obj = {
          // pallet_id : value.pallet_id,
         mezone_id: value.mezone_id,
            // mezone_id:value.mezone_id,
            // mezone_name:value.mezone_name,
         // country_code:value.country_code,
         // created_date:value.created_date,
        hub_id:`${userInfo.pickuplocationmasterid}`,
              
            
      
      };  
       
  
// getshipmentlistfromlinehaulpallet

         this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmezonedetails`,Obj)
        .then((result) => {
          // console.log("mezone",result);
          if (result.body.returnmsg === 'Successful') {
             
          
           
               this.shipmentlist  = result.body.returnvalue
           // console.log(this.shipmentlist);
                
                this.melisting=result.body.returnvalue.shipment_list;
                this.total_row_shipment=result.body.returnvalue.shipment_list.length;
               this.melistingmodel = true;
           
          } 
          else {
          this.melisting=result.body.returnvalue;

          this.melistingmodel = true;
            
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    
      
      
    },
    editcancel: function() {
        this.tags=[];
      this.customer = {};
      this.editAgentMaster = !this.editAgentMaster;
      
    },
    refresh:function() {
     
      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      var addzone = document.getElementById("addzone");
      addzone.style.display = "none";
      this.clear();
    },
   
    
    displaydata: function () {
      // alert("getlinehaulpalletlisting");
    this.isBusy = true;
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

       const obj = {
        hub_id:`${userInfo.pickuplocationmasterid}`,
        submit_via:'DHL',
      };
      

      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmezonelist`,obj)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
             this.items  = result.body.returnvalue;
             // console.log(this.items);
             // this.items=[];
             // this.totalRows =0;
             this.totalRows = result.body.returnvalue.length;
             this.isBusy = !this.isBusy;
          } else {
            this.items=result.body.returnvalue;
            this.totalRows =0;
               this.isBusy = !this.isBusy;
          }
          // this.meproductdetails();
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
    
     
    clear: function() {
      this.zoneno = '';
       this.tags2=[];
      this.errors.clear('form-1')    
    }    
    
  }

 
};
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
  .nameOfTheClass {
   max-width: 166px !important;
}
.ti-new-tag-input-wrapper input[data-v-61d92e31] {
    flex: 1 0 auto;
    min-width: 310px;
    border: none;
    padding: 0px;
    margin: 0px;
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
/*tbody tr:nth-child(odd) {
    background: darkgray !important;
}*/
</style>
